import { createReducer } from '@reduxjs/toolkit';
import { RequestError, HistoricPendingCommunication } from 'types';
import {
  fetchHistoricPendingCommunication,
  fetchedHistoricPendingCommunication,
  deleteHistoricPendingCommunication,
  deletedHistoricPendingCommunication,
} from './actions';
import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  errorType: undefined,
  data: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchHistoricPendingCommunication, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedHistoricPendingCommunication, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.data = undefined;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
        state.data = payload as HistoricPendingCommunication;
      }
    })
    .addCase(deleteHistoricPendingCommunication, (state) => {
      state.status = 'loading';
    })
    .addCase(deletedHistoricPendingCommunication, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
        state.errorType = 'delete';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })
);
